var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticStyle:{"float":"right!important"},attrs:{"id":"modal-bronlist","hide-footer":"","size":"lg"},on:{"shown":_vm.Shoved1,"hidden":function($event){return _vm.Hide()}}})}
var staticRenderFns = []

export { render, staticRenderFns }